import { useRef }                   from 'react';
import MassBalanceFilter            from '../components/Filters/MassBalanceFilter'
import MassBalanceContainer         from '../components/Form/MassBalanceContainer'
import MassBalanceTable             from '../components/Table/MassBalanceTable'
import MassBalanceTableContainer    from '../components/Table/MassBalanceTableContainer'
import MassBalanceProductFilter     from '../components/Filters/MassBalanceProductFilter'
import MassBalanceHeatmapTableContainer from '../components/Table/MassBalanceHeatmapTableContainer'
import { useMassBalancePage }       from '../contexts/MassBalancePageContext'
import { useUser }                  from '../contexts/UserContext'
import { findPermission }       from '../utils/UserPermissionUtils.js'  


function MassBalancePage() {

    const massBalanceContainerRef = useRef(null);
    const { selectedViewType } = useMassBalancePage();
    const { userData } = useUser();

    const handleOpenMassBalanceModal = () => {
        if (massBalanceContainerRef.current) {
            massBalanceContainerRef.current.handleModalFileOpen();
        }
    };

    return (

        <div className="pg-content flex flex-col gap-4">

            <h1>Balanço de Massa</h1>

            <MassBalanceContainer ref={massBalanceContainerRef} />
            <MassBalanceFilter onOpenMassBalanceModal={handleOpenMassBalanceModal} />         

            

                <div className={selectedViewType === 'tabela' ? '' : 'hidden'}>
                    <MassBalanceProductFilter />
                </div>

            

            {selectedViewType === 'heatmap' && <MassBalanceHeatmapTableContainer />}
            {selectedViewType === 'tabela'  && <MassBalanceTableContainer />}
            

        </div>

    )
}

export default MassBalancePage;